import { Component, input, InputSignal } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SectionCardInterface } from '../../data/interfaces/SectionCardInterface';

@Component({
  selector: 'app-inspections-card',
  imports: [FontAwesomeModule],
  templateUrl: './inspections-card.html',
  styleUrl: './inspections-card.scss',
})
export class InspectionsCard {
  card: InputSignal<SectionCardInterface> = input<SectionCardInterface>({
    title: 'titulo',
    content: 'contenido',
    imgLink: '#',
    link: 'assets/inspections-card-1.jpg'
  })
  

}
